import { getImageSources } from "@dotcom/dato";
import { convertFocalPointToCssObjectPosition } from "@dotcom/ui";
import {
  AspectRatio,
  AspectRatios,
  Breakpoints,
  Image,
  Picture,
} from "@polestar/component-warehouse-react";

import { Section } from "~/common/components";
import { type ParsedImage } from "~/common/types";

interface Props {
  readonly imageMobile?: ParsedImage;
  readonly imageTablet?: ParsedImage;
  readonly imageDesktop?: ParsedImage;
  readonly sectionSlug?: string;
}

const NewsImageSection = ({
  imageMobile,
  imageTablet,
  imageDesktop,
  sectionSlug,
}: Props) => {
  const imageSources = getImageSources({
    mobile: {
      url: imageMobile ? imageMobile.url : imageDesktop?.url,
      imageWidth: 900,
      breakpoint: Breakpoints.mobile,
    },
    tablet: {
      url: imageTablet ? imageTablet.url : imageDesktop?.url,
      imageWidth: 960,
      breakpoint: Breakpoints.tablet,
    },
    desktop: {
      url: imageDesktop?.url,
      imageWidth: 1248,
      breakpoint: Breakpoints.desktop,
    },
    desktopWide: {
      url: imageDesktop?.url,
      imageWidth: 1920,
      breakpoint: Breakpoints.desktopWide,
    },
  });

  return (
    <Section media id={sectionSlug}>
      <AspectRatio
        ratio={{
          mobile: AspectRatios.tall,
          tablet: AspectRatios.xWide,
        }}
      >
        <Picture stretch>
          {imageSources.sources.map(({ media, srcSet }) => {
            return <source key={media} srcSet={srcSet} media={media} />;
          })}
          <Image
            stretch
            src={imageSources.source}
            alt={imageDesktop?.alt ?? ""}
            objectFit="cover"
            objectPosition={{
              mobile: convertFocalPointToCssObjectPosition(
                imageMobile?.focalPoint
              ),
              tablet: convertFocalPointToCssObjectPosition(
                imageTablet?.focalPoint
              ),
              desktop: convertFocalPointToCssObjectPosition(
                imageDesktop?.focalPoint
              ),
              desktopWide: convertFocalPointToCssObjectPosition(
                imageDesktop?.focalPoint
              ),
            }}
          />
        </Picture>
      </AspectRatio>
    </Section>
  );
};

export default NewsImageSection;
